// frontend/src/components/CategoriaModal/CategoriaModal.jsx

import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Alert } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { createCategoria, updateCategoria } from '../../services/categoryService';
import { getErrorMessage } from '../../utils/errorHandler';
import { getMobileFullscreenModalProps } from '../../utils/mobileModal';

const { Option } = Select;

const CategoriaModal = ({ isOpen, onClose, onSave, categoria }) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(''); 
    
    const isEditing = !!categoria;

    useEffect(() => {
        if (isOpen) {
            setError('');
            if (isEditing) {
                form.setFieldsValue(categoria);
            } else {
                form.resetFields();
            }
        }
    }, [isOpen, categoria, form, isEditing]);

    const handleOk = async () => {
        // BLINDAGEM: Se já estiver enviando, ignora novos cliques
        if (loading) return;

        try {
            const values = await form.validateFields();
            setLoading(true);
            setError('');

            if (isEditing) {
                await updateCategoria(categoria.id, values);
                onSave('Categoria atualizada com sucesso!');
            } else {
                await createCategoria(values);
                onSave('Categoria criada com sucesso!');
            }
        } catch (err) {
            if (err.errorFields) return; 
            setError(getErrorMessage(err, 'Erro ao salvar a categoria.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={isEditing ? 'Editar Categoria' : 'Nova Categoria'}
            open={isOpen}
            onOk={handleOk}
            onCancel={onClose}
            okText="Salvar"
            cancelText="Cancelar"
            confirmLoading={loading}
            maskClosable={!loading}
            closable={!loading}
            destroyOnClose
            okButtonProps={{ block: isMobile, size: isMobile ? 'large' : 'middle' }}
            cancelButtonProps={{ block: isMobile, size: isMobile ? 'large' : 'middle' }}
            {...getMobileFullscreenModalProps(isMobile)}
        >
            {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}
            
            <Form form={form} layout="vertical" disabled={loading} size={isMobile ? 'large' : 'middle'}>
                <Form.Item
                    name="nome"
                    label="Nome da Categoria"
                    rules={[{ required: true, message: 'Por favor, insira o nome!' }]}
                >
                    <Input placeholder="Ex: Alimentação" />
                </Form.Item>
                <Form.Item
                    name="tipo"
                    label="Tipo"
                    rules={[{ required: true, message: 'Selecione o tipo!' }]}
                >
                    <Select placeholder="Selecione" disabled={isEditing}>
                        <Option value="receita">Receita</Option>
                        <Option value="despesa">Despesa</Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CategoriaModal;